<div echarts [options]="adaptedOptions()" [initOpts]="initOpts" class="annuity-chart"></div>
@if (showLegacySliders()) {
  <div class="sliders-panel">
    @if (params().mode === 'saving') {
      <dojo-slider
        param="PMT"
        [min]="resolvedSliderConfig().pmt.min"
        [max]="resolvedSliderConfig().pmt.max"
        [step]="resolvedSliderConfig().pmt.step"
        [value]="effectivePmt()"
        [editable]="true"
        color="pink"
        variant="minimal"
        (valueChange)="onPmtChange($event)"
      />
    }
    @if (params().mode === 'loan') {
      <dojo-slider
        param="PV"
        [min]="resolvedSliderConfig().pv.min"
        [max]="resolvedSliderConfig().pv.max"
        [step]="resolvedSliderConfig().pv.step"
        [value]="effectivePv()"
        [editable]="true"
        color="pink"
        variant="minimal"
        (valueChange)="onPvChange($event)"
      />
    }
    <dojo-slider
      param="Rate %"
      [min]="resolvedSliderConfig().rate.min"
      [max]="resolvedSliderConfig().rate.max"
      [step]="resolvedSliderConfig().rate.step"
      [value]="effectiveRate()"
      [editable]="true"
      color="teal"
      variant="minimal"
      (valueChange)="onRateChange($event)"
    />
    <dojo-slider
      param="N"
      [min]="resolvedSliderConfig().periods.min"
      [max]="resolvedSliderConfig().periods.max"
      [step]="resolvedSliderConfig().periods.step"
      [value]="effectivePeriods()"
      [editable]="true"
      color="neutral"
      variant="minimal"
      (valueChange)="onPeriodsChange($event)"
    />
  </div>
}
@if (tvmCells(); as cells) {
  <div class="tvm-panel">
    @for (cell of cells; track $index) {
      <div class="tvm-cell" [class.tvm-cell--editable]="cell.editable">
        <span class="tvm-cell__header">
          <span class="tvm-cell__label" [innerHTML]="cell.labelHtml"></span>
          <dojo-icon icon="circle-info" class="tvm-cell__info" [matTooltip]="cell.tooltip" matTooltipPosition="above" />
        </span>
        @if (cell.editable) {
          <dojo-slider
            [param]="cell.field"
            [min]="cell.min"
            [max]="cell.max"
            [step]="cell.step"
            [value]="cell.value"
            [editable]="true"
            [color]="cell.color"
            [showLabel]="false"
            variant="minimal"
            (valueChange)="onCellEdit(cell.field, $event)"
          />
        } @else {
          <span class="tvm-cell__value">{{ cell.displayValue }}</span>
        }
      </div>
    }
  </div>
  @if (tvmResult(); as result) {
    <div class="tvm-result">
      <div class="tvm-result__main">
        <span class="tvm-result__label"
          >{{ result.label }}
          <dojo-icon
            icon="circle-info"
            class="tvm-result__info"
            [matTooltip]="result.tooltip"
            matTooltipPosition="above"
          />
        </span>
        <span class="tvm-result__value">{{ result.value }}</span>
      </div>
      <div class="tvm-result__divider"></div>
      <div class="tvm-result__duration" [innerHTML]="result.durHtml"></div>
      <div class="tvm-result__divider"></div>
      <div class="tvm-result__duration" [innerHTML]="result.rateHtml"></div>
    </div>
  }
}
